import {
  Mark,
  markInputRule,
  markPasteRule,
  mergeAttributes,
} from '@tiptap/core'

export const kbdInputRegex = /(?:^|\s)((?:<kbd>)((?:[^*]+))(?:<\/kbd>))$/
export const kbdPasteRegex = /(?:^|\s)((?:<kbd>)((?:[^*]+))(?:<\/kbd>))/g

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    Kbd: {
      toggleKbd: () => ReturnType
    }
  }
}

export const Kbd = Mark.create({
  name: 'kbd',
  inclusive: true,
  priority: 1001,
  addOptions() {
    return {
      HTMLAttributes: {
        class: 'rt-kbd',
      },
    }
  },

  parseHTML() {
    return [{ tag: 'kbd' }]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'kbd',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ]
  },

  // @ts-ignore
  addCommands() {
    return {
      setKbd:
        () =>
        // @ts-ignore
        ({ commands }) => {
          return commands.setMark('kbd')
        },
      toggleKbd:
        () =>
        // @ts-ignore
        ({ commands }) => {
          return commands.toggleMark('kbd')
        },
      unsetKbd:
        () =>
        // @ts-ignore
        ({ commands }) => {
          return commands.unsetMark('kbd')
        },
    }
  },

  addKeyboardShortcuts() {
    return {
      // @ts-ignore
      'Mod-^': () => this.editor.commands.toggleKbd(),
    }
  },

  addInputRules() {
    return [
      markInputRule({
        find: kbdInputRegex,
        type: this.type,
      }),
    ]
  },

  addPasteRules() {
    return [
      markPasteRule({
        find: kbdPasteRegex,
        type: this.type,
      }),
    ]
  },
})
